module.exports = __webpack_public_path__ + "static/media/blueWireTransfer.764ea912.svg";